import React, { useEffect } from 'react';
import { getCurrentUser } from 'aws-amplify/auth';
import { Outlet, useNavigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children?: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkUser = async () => {
      try {
        await getCurrentUser();
      } catch (error) {
        navigate('/login');
      }
    };
    checkUser();
  }, [navigate]);

  return <Outlet />;
};

export default ProtectedRoute;
